import qs from 'qs';
import { TLanguageInfo } from 'interfaces';

export type TPathWithQuery = {
  path: string;
  queryParams: { [key: string]: string };
};

const shouldOmitLanguageSlug = (languageInfo?: TLanguageInfo) =>
  languageInfo
    ? languageInfo.isCustomDomain && languageInfo.domainId
      ? languageInfo.isDefaultDomain
      : languageInfo.default
    : true;

const extractPathAndQuery = (
  url: string,
  languageSlug: string
): TPathWithQuery => {
  const [path, queryText] = (
    languageSlug ? url.replace(`/${languageSlug}`, '') : url
  ).split('?');

  let queryParams = {};

  if (queryText) {
    queryParams = qs.parse(queryText);
  }

  return {
    path: queryText ? [path, queryText].join('?') : path,
    queryParams
  };
};

const getPathWithCorrectLang = (path: string, languageInfo?: TLanguageInfo) => {
  const languageSlug = languageInfo?.slug || '';
  const pathWithoutQuery = extractPathAndQuery(path, languageSlug).path;

  const omitLanguageSlug = shouldOmitLanguageSlug(languageInfo);

  if (omitLanguageSlug) {
    return pathWithoutQuery;
  } else {
    return `/${languageSlug}${pathWithoutQuery}`;
  }
};

export const getPath = (path: string) => {
  if (window.__NEXT_DATA__) {
    return getPathWithCorrectLang(
      path,
      window.__NEXT_DATA__.props.pageProps.languageInfo
    );
  }
  if (window.currentLanguageObject) {
    const languageSlug =
      window.currentLanguageObject.default === 1
        ? ''
        : `/${window.currentLanguageObject.prefix}`;
    return `${languageSlug}${path}`;
  }
  return path;
};
